import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {UtilsService} from '../../core/utils/utils.service';
import {GenericFormService} from '../../core/services/generics/generic-form.service';
import {ParametresService} from '../../core/services/entities/parametres.service';
import {MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {ToastService} from "../../core/services/technique/toast.service";
import {Subscription} from "rxjs";
import {AdministrationService} from "../../core/services/gestion-administration/administration.service";

@Component({
  selector: 'yo-parametres',
  templateUrl: './parametres.component.html',
  styleUrls: ['./parametres.component.scss']
})
export class ParametresComponent implements OnInit, OnDestroy {

  form: FormGroup;
  refresh = 1;
  subTauxDePerte: Subscription;
  useTauxDePerte: Boolean = false;

  constructor(public utils: UtilsService,
              private gfs: GenericFormService,
              private parametresSvc: ParametresService,
              private toastSvc: ToastService,
              private administrationSvc: AdministrationService) {
  }

  initForm = () => {

    this.subTauxDePerte = this.administrationSvc.tauxDePerte().subscribe((result) => {
      this.useTauxDePerte = result.one;
    });

    this.form = new FormGroup({
      background: new FormControl(undefined),
      logo:new FormControl(undefined)
    });
  };

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subTauxDePerte);
  }

  onChangeImage = (event, formControlName:string) => {
    console.log('onChangeImage');
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      this.form.controls[formControlName].setValue(file);
    }
  };


  save = () => {

    this.gfs.validateAllFormFields(this.form);

    if (this.form.valid) {
      this.parametresSvc.savePreferences(this.form.controls['background'].value, this.form.controls['logo'].value, this.useTauxDePerte).subscribe(response => {
        this.refresh = new Date().getTime();
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le fond d'écran et le logo ont été enregistrés avec succès. Veuillez recharger votre page en appuyant sur la touche F5 afin d'afficher les nouvelles modifications apportées`);
      });
    }

  };


}
